import React from "react";
import { Link } from 'react-router-dom';
import { Button, Section } from 'react-bulma-components';

const NotFound = ()=> {
  return (
      <div style={{ display: 'flex', height: '100%'}}>
          <Section>
              <h1>404</h1>
              <h2>Nothing to see here!</h2>
              <div className="page">
              <hr />
                  <p>
                    <Button renderAs={ Link } to="/">Back to Homepage</Button>
                  </p>
              </div>
          </Section>
      </div>
  );
}

export default NotFound;
